import { render, staticRenderFns } from "./AppReviewComments.vue?vue&type=template&id=aa964df0&scoped=true"
import script from "./AppReviewComments.vue?vue&type=script&lang=js"
export * from "./AppReviewComments.vue?vue&type=script&lang=js"
import style0 from "./AppReviewComments.vue?vue&type=style&index=0&id=aa964df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa964df0",
  null
  
)

export default component.exports